import { memo } from 'react';
const SvgAlignJustify = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    className="align-justify_svg__feather align-justify_svg__feather-align-justify"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M21 10H3M21 6H3M21 14H3M21 18H3" />
  </svg>
);
const Memo = memo(SvgAlignJustify);
export default Memo;
